export const CANCELLATION_REASONS = {
  RESCHEDULE: "reschedule",
  NOT_READY: "not_ready",
  DIFFERENT_COACH: "different_coach",
  OTHER: "other",
} as const;
